import React from 'react'

function Registerbundit2() {
  return (
    <div className='container-fluid' >
      <div className='bg-danger' >
 fgdfg
      </div>
    </div>
  )
}

export default Registerbundit2
